<template>
  <v-container class="mt-5 mb-10" style="height: 100vh">
    <v-card flat class="rounded-xl inherit-height">
      <v-data-table
        rounded
        fixed-header
        :headers="headers"
        :items="filteredAndAggregatedData"
        item-key="id"
        :custom-sort="customSort"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :height="mdAndUp ? 800 : 600"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-skip-backward',
          lastIcon: 'mdi-skip-forward',
          prevIcon: 'mdi-skip-previous',
          nextIcon: 'mdi-skip-next',
          'items-per-page-options': [-1, 20, 50, 100, -1],
        }"
        class="elevation-0 pt-4 mb-10"
      >
        <template v-slot:top>
          <v-toolbar flat height="100">
            <v-menu
              ref="dateFromMenu"
              v-model="dateFromMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              z-index="999"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="dateFromFormatted" label="von" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="dateFrom" first-day-of-week="1" no-title scrollable locale="GE-de">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateFromMenu = false"> Cancel </v-btn>
                <v-btn text color="primary" @click="dateFromMenu = false"> OK </v-btn>
              </v-date-picker>
            </v-menu>
            <v-menu ref="dateToMenu" v-model="dateToMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto" z-index="999">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="dateToFormatted" label="bis" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="dateTo" first-day-of-week="1" no-title scrollable locale="GE-de">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateToMenu = false"> Cancel </v-btn>
                <v-btn text color="primary" @click="dateToMenu = false"> OK </v-btn>
              </v-date-picker>
            </v-menu>
            <v-checkbox label="Tage ausweisen" v-model="reportByDay"></v-checkbox>
            <v-btn small outlined color="primary" dark class="ml-3 mb-5 d-print-none" @click="exportData">export</v-btn>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import api from '../api';
import CsvExportor from 'csv-exportor';
import { mapState } from 'vuex';
import commonMixin from '@/mixins/common';

export default {
  mixins: [commonMixin],
  mounted() {
    this.loadData();
    this.dateFrom = dateUtils.formatDateAsYYYYMMDD(this.contextDate ? this.contextDate : new Date());
    this.dateTo = dateUtils.formatDateAsYYYYMMDD(this.contextDate ? this.contextDate : new Date());
  },

  data() {
    return {
      sortBy: 'date',
      sortDesc: false,
      absenceReasons: [],
      dateFromMenu: false,
      dateFrom: null, //dateUtils.formatDateAsYYYYMMDD(new Date(Date.now() - 0 * 1000 * 60 * 60 * 24)),
      dateToMenu: false,
      dateTo: null, //dateUtils.formatDateAsYYYYMMDD(new Date()),
      items: [],
      reportByDay: true,
      headers: [
        {
          text: 'Datum',
          align: 'start',
          sortable: true,
          value: 'date',
        },
        {
          text: 'Abteilung',
          align: 'start',
          sortable: true,
          value: 'fzgType',
        },
        {
          text: 'Grund',
          align: 'start',
          sortable: true,
          value: 'reason',
        },
        {
          text: 'Anzahl',
          align: 'start',
          sortable: true,
          value: 'count',
        },
      ],
    };
  },

  computed: {
    ...mapState('vbzWorksheet', ['contextDate']),
    contextDateAsDateObj() {
      let d = new Date(Date.parse(this.contextDate));
      console.debug('UTC String=', d.toUTCString());
      return d;
    },
    dateToFormatted() {
      return this.formatYYYYMMDD(this.dateTo);
    },
    dateFromFormatted() {
      return this.formatYYYYMMDD(this.dateFrom);
    },
    filteredAndAggregatedData() {
      console.debug('dateFrom', this.dateFrom);
      if (!this.dateFrom || !this.dateTo) {
        return [];
      }
      let dateFrom = dateUtils.parseYYYYMMDD(this.dateFrom).getTime() + new Date().getTimezoneOffset() * 60000;
      let dateTo = dateUtils.parseYYYYMMDD(this.dateTo).getTime() + 20 * 60 * 60 * 1000 + new Date().getTimezoneOffset() * 60000; // +20 h because of timezone offset and different setting on VBZ server (however that is strange, but did not have time to search for the root cause)
      console.debug('dateFrom', new Date(dateFrom));
      console.debug('dateTo', new Date(dateTo));
      let items = this.items
        // map and add date values
        .map((i) => {
          let dateAsMillis = new Date(i.date); //Date.parse(i.date);
          let dateObj = new Date(dateAsMillis);
          return { ...i, dateAsMillis, dateFormatted: dateUtils.formatAsLocaleShortDate(dateObj) };
        })
        // Filter by dates
        .filter((i) => {
          return dateFrom <= i.dateAsMillis && dateTo >= i.dateAsMillis;
        });

      let countByDateReasonVehicleType = {};
      items.forEach((i) => {
        let key;
        if (!this.reportByDay) {
          key = `${i.reason}_${i.fzgType || 'na'}`;
        } else {
          key = `${i.dateFormatted}_${i.reason}_${i.fzgType || 'na'}`;
        }

        let count = countByDateReasonVehicleType[key];
        if (!count) {
          count = 0;
        }
        countByDateReasonVehicleType[key] = count + 1;
      });
      let aggregatedItems = Object.keys(countByDateReasonVehicleType).map((key) => {
        let keyParts = key.split('_');
        if (!this.reportByDay) {
          return {
            date: `${this.dateFromFormatted} - ${this.dateToFormatted}`,
            fzgType: keyParts[1] || 'na',
            reason: keyParts[0],
            count: countByDateReasonVehicleType[key],
          };
        }
        return {
          date: keyParts[0],
          fzgType: keyParts[2] || 'na',
          reason: keyParts[1],
          count: countByDateReasonVehicleType[key],
          dateAsMillis: keyParts[3],
        };
      });
      return aggregatedItems;
    },
  },

  methods: {
    customSort: function (items, sortableFieldsArr, isDescArr) {
      if (sortableFieldsArr.length === 0) return items;
      let field = sortableFieldsArr[0];
      let isDesc = isDescArr[0];

      let ret1 = isDesc ? -1 : 1;
      let ret2 = isDesc ? 1 : -1;

      if (field === 'date') {
        return items.sort((a, b) => (a.dateAsMillis > b.dateAsMillis ? ret2 : ret1));
      }
      return items.sort((a, b) => (a[field] > b[field] ? ret1 : ret2));
    },
    formatYYYYMMDD(yyyymmdd) {
      let date = dateUtils.parseYYYYMMDD(yyyymmdd);
      if (date && date.getMonth) {
        return dateUtils.formatAsLocaleShortDate(date);
      }
      return 'kein Datum';
    },
    formatDate(dateYYYYMMDD) {
      if (!dateYYYYMMDD) return null;
      let date = dateUtils.parseYYYYMMDD(dateYYYYMMDD);
      let formattedDate = dateUtils.formatAsLocaleShortDate(date);
      console.debug('formatted Date', date, formattedDate);
      return formattedDate;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    async loadData() {
      try {
        let response = await api.fetchAll('anonymousIllnessReason');
        this.items = response.data;
      } catch (err) {
        console.warn('Failed to load report data');
      }
    },
    exportData() {
      let cleansedData = this.filteredAndAggregatedData.map((m) => {
        let { date, fzgType, reason, count } = m;
        return { date, fzgType: fzgType || 'na', reason, count };
      });
      if (this.reportByDay) {
        CsvExportor.downloadCsv(
          cleansedData,
          {
            header: ['Datum', 'Abteilung', 'Grund', 'Anzahl'],
            cellDelimiter: ';',
          },
          `Absenzen_Report_${this.reportByDay ? 'pro-tag_' : ''}${this.dateFromFormatted}-${this.dateToFormatted}.csv`
        );
      } else {
        CsvExportor.downloadCsv(
          cleansedData,
          {
            header: ['Datum', 'Abteilung', 'Grund', 'Anzahl'],
            cellDelimiter: ';',
          },
          `Absenzen_Report_${this.reportByDay ? 'Zeitraum_' : ''}${this.dateFromFormatted}-${this.dateToFormatted}.csv`
        );
      }
    },
  },
  watch: {
    dateFrom(newValue, oldValue) {
      this.loadData();
    },
    dateTo(newValue, oldValue) {
      this.loadData();
    },
  },
};
</script>
